import { h } from "preact";
import { Button, Input, Select, Radio } from "antd";
import { CheckboxTree } from "./ChecboxTree";
import { FileUpload } from "./FileUpload";

const { Option } = Select;

const GENERAL_PARAMS = ["allow_failure", "timeout", "max_retries"];

export const ServiceCardContent = ({
  service,
  setServices,
  onUpdateInput,
  onUpdateCheckbox,
  onUpdateSelect,
  onUpdateRadioGroup,
  onUpdateChildCheckbox,
  onCheckboxNested,
  onSelectNested,
  onUploadFile,
  onRemoveFile,
  personId,
}) => {
  const serviceWithoutGeneral = service.params.filter(
    (p) => !GENERAL_PARAMS.includes(p.paramName)
  );
  const serviceWithGeneral = service.params.filter((p) =>
    GENERAL_PARAMS.includes(p.paramName)
  );

  const handleOpen = (serviceId) => {
    setServices((prev) =>
      prev.map((s) => (s.id === serviceId ? { ...s, isOpen: !s.isOpen } : s))
    );
  };

  return (
    <div>
      {serviceWithoutGeneral.map((param) => {
        if (param.type === "input") {
          return (
            <Input
              key={param.id}
              placeholder={param.placeholder}
              value={param.value}
              onChange={(e) => onUpdateInput(service.id, param.id, e.target.value)}
              style={{ marginTop: 8 }}
            />
          );
        }

        if (param.type === "checkbox-select") {
          return (
            <div
              key={param.id}
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: "10px" }}
            >
              <div>
                <input
                  type="checkbox"
                  id={param.id}
                  checked={param.enabled}
                  value={param.value}
                  onChange={() => onUpdateCheckbox(service.id, param.id)}
                />
                <label className="checkbox-select-label" htmlFor={param.id} style={{ marginLeft: "10px" }}>
                  {param.id}
                </label>
              </div>
              <Select
                onChange={(value) => onUpdateSelect(service.id, param.id, value)}
                disabled={!param.enabled}
                value={param.value}
                style={{ width: "50%" }}
              >
                {param.options.map((option) => (
                  <Option key={option} value={option} />
                ))}
              </Select>
            </div>
          );
        }

        if (param.type === "file-upload" && onUploadFile) {
          return (
            <div key={param.id} className="mt-4">
              <FileUpload
                onChange={(file, uid) => onUploadFile(file, uid, service.paramName)}
                onRemove={(uid) => onRemoveFile(uid, service.paramName)}
                personId={personId}
              />
            </div>
          );
        }

        if (param.type === "radio-group") {
          return (
            <div key={param.id} style={{ paddingTop: "10px" }}>
              <Radio.Group
                value={param.value}
                onChange={(e) => onUpdateRadioGroup(service.id, param.id, e.target.value)}
              >
                {param.options.map((option) => (
                  <Radio key={option.value} value={option.value}>{option.label}</Radio>
                ))}
              </Radio.Group>
              {param.options.map((option) => {
                if (option.value !== param.value || !option.params) return null;
                return (
                  <div key={option.value} style={{ marginTop: "10px" }}>
                    {option.params.map((childParam) => (
                      <div key={childParam.id}>
                        <input
                          type="checkbox"
                          id={childParam.id}
                          checked={childParam.enabled}
                          onChange={(e) =>
                            onUpdateChildCheckbox(service.id, param.id, option.value, childParam.id, e.target.checked)
                          }
                        />
                        <label
                          htmlFor={childParam.id}
                          className="checkbox-select-label"
                          style={{ marginLeft: "10px", position: "static" }}
                        >
                          {childParam.id}
                        </label>
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          );
        }

        if (param.type === "checkbox") {
          return (
            <div key={param.id}>
              <CheckboxTree
                param={param}
                serviceId={service.id}
                updateCheckbox={onCheckboxNested}
                updateSelectParam={onSelectNested}
              />
            </div>
          );
        }

        return null;
      })}

      {serviceWithGeneral.length > 0 && (
        <Button style={{ marginTop: "20px" }} onClick={() => handleOpen(service.id)}>
          {service.isOpen ? "Hide general settings" : "Show general settings"}
        </Button>
      )}

      {serviceWithGeneral.length > 0 && service.isOpen && (
        <div>
          {serviceWithGeneral.map((param) => (
            <div
              key={param.id}
              style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: "10px" }}
            >
              <div>
                <input
                  id={`${service.name}-${param.id}`}
                  type="checkbox"
                  value={param.value}
                  checked={param.enabled}
                  onChange={() => onUpdateCheckbox(service.id, param.id)}
                />
                <label
                  className="checkbox-select-label"
                  htmlFor={`${service.name}-${param.id}`}
                  style={{ marginLeft: "10px", position: "static" }}
                >
                  {param.id}
                </label>
              </div>
              <Select
                onChange={(value) => onUpdateSelect(service.id, param.id, value)}
                disabled={!param.enabled}
                value={param.value}
                style={{ width: "50%" }}
              >
                {param.options.map((option) => (
                  <Option key={option} value={option} />
                ))}
              </Select>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
